import { TextField } from '@mui/material';

type PercentInputProps = {
  value: number | undefined;
  onChange: (value: number | undefined) => void;
  disabled?: boolean;
};

export const PercentInput = (p: PercentInputProps) => {
  const onChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = ev.target.value;

    if (!inputValue) {
      p.onChange(undefined);
      return;
    }
    if (parseInt(inputValue) < 0) {
      return;
    }
    if (parseInt(inputValue) > 100) {
      return;
    }

    const res = parseInt(inputValue, 10);
    p.onChange(isNaN(res) ? undefined : res);
  };
  return (
    <TextField
      sx={{
        width: '100%',
        height: '100%',
        borderRadius: '6px',
      }}
      disabled={!!p.disabled}
      value={p.value ?? ''}
      type="number"
      onChange={onChange}
      onWheel={(event) => {
        event.preventDefault();
      }}
      onKeyDownCapture={(event) => {
        if (
          event?.key === '-' ||
          event?.key === '+' ||
          event?.key === ',' ||
          event?.key === '.'
        ) {
          event.preventDefault();
        }
      }}
      InputProps={{
        inputProps: { min: 0, max: 100, 'aria-label': 'percentInput' },
        sx: {
          input: {
            '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
              '-webkit-appearance': 'none',
            },
          },
        },
      }}
    />
  );
};
